<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">OSBOD Aanmelding</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title>
		</v-card-title>
		<v-card-text>
			<!-- <p class="font-weight-bold">Bevestiging Aanmelding schooljaar 2022-2023</p>
			<p class="font-weight-regular">Beste heer/mevrouw,</p>
			<p class="font-weight-regular">
					
				Hierbij bevestigen wij de ontvangst van uw inschrijving.
				Wij nemen uw inschrijving in behandeling en verwachten u binnenkort te kunnen berichten.
				Indien wij aanvullende informatie nodig hebben zullen wij contact met u opnemen.</p>
			<p class="font-weight-regular">

				Wij stellen het zeer op prijs dat u bij ons zich heeft aangemeld.</p>
			<p class="font-weight-regular">
				Met vriendelijke groet,</p>
			<p></p>
			<p class="font-weight-regular">

				OSBOD Administratie
			</p>
			<a href="http://www.osbod.org">Terug naar website OSBOD</a> -->
			<p class="font-weight-bold">Konfirmashon di registrashon pa aña skolar 2026-2027</p>
			<p class="font-weight-regular">Apresiabel señor/ señora,</p>
			<p class="font-weight-regular">
					
				Pa medio di esaki nos ta konfirmá ku nos a risibí bo inskripshon.
				Nos lo prosesá bo inskripshon i lo tuma kontakto bèk pronto.
				Den kaso nos mester di informashon adishonal, nos lo tuma kontakto ku bo.</p>
			<p class="font-weight-regular">

				Nos ta apresiá ku bo a registrá bo mes serka nos.</p>
			<p class="font-weight-regular">
				Saludo kordial,</p>
			<p></p>
			<p class="font-weight-regular">

				Atministrashon OSBOD.
			</p>
			<a href="http://www.osbod.org">Bai bèk na website di OSBOD</a>
		</v-card-text>
	</v-card>
		<!-- <v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">OSBOD Students</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title>
			<v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details>
			</v-text-field>
		</v-card-title>

		<v-data-table :headers="headers" :items="data" :search="search" :loading="loading">
			<template v-slot:top>
				<v-toolbar dark dense color="primary" flat class="mb-1">
					<v-btn depressed class="ml-2" @click="setStudentIntake()" color="inverted">
						<v-icon class="pr-2">mdi-plus-circle</v-icon>Add Student
					</v-btn>
				</v-toolbar>
			</template>
			<template v-slot:item.action="{ item }">
				<v-icon @click="handleClick(item.id)">mdi-account-edit</v-icon>
			</template>
		</v-data-table>
	</v-card> -->
</template>

<script>
	import Axios from "axios";
	//import _ from "lodash";
	import {
		API_ROOT
	} from "../../config";
	console.log(API_ROOT.osbod_salary);
	const ax = Axios.create({
		baseURL: API_ROOT["osbod_salary"],
		timeout: 60000
	});

	export default {
		name: "userregistrations",
		data() {
			return {
				user: localStorage.getItem("user"),
				search: "",
				headers: [{
						text: "",
						align: "center",
						sortable: false,
						value: "action"
					},
					{
						text: "Student Status",
						value: "old_student"
					},
					{
						text: "Schoolyear",
						value: "tbl_sys_schoolyear.name"
					},
					{
						text: "Study",
						value: "tbl_sys_study.name"
					},
					// {
					// 	text: "Government ID",
					// 	value: "government_id"
					// },
					{
						text: "Student",
						value: "display_name"
					},
					{
						text: "Mobiel",
						value: "tel_mobile"
					},
					{
						text: "Thuis",
						value: "tel_home"
					},{
						text: "Werk",
						value: "tel_work"
					},

					// { text: "Active", value: "tbl_userregistration.userregistration_active" }

				],
				// semesters: [],
				// studies: [],
				// subjects: [],
				// subjecttypes: [],
				// selected_subject: null,
				// selected_kwalificatie: null,
				// selected_deelkwalificatie: null,
				// selected_semester: null,
				// schoolyear: [],
				// selected_schoolyear: null,
				data: [],
				// banktypes: [],
				isEmpty: false,
				loading: false,
				isPaginated: true,
				isPaginationSimple: false,
				defaultSortDirection: "asc",
				currentPage: 1,
				perPage: 15
			};
		},
		created: function () {
			// this.getBanktypes();
			this.getStudentIntakes();
		},
		watch: {
			// selected_kwalificatie: function(value) {
			// 	this.getStudySubjecttype(value);
			// 	console.log(value);
			// }
		},
		computed: {
			// school() {
			// 	return this.$store.getters.getSchool;
			// }
		},
		methods: {
			handleClick(id) {
				this.$router.push({
					path: "/schooladmin/studentregistration/update/" + id
				});
			},
			setStudentIntake: function () {
				this.$router.push({
					path: "/schooladmin/studentregistration/new"
				});
			},
			getStudentIntakes: function () {
				var self = this;
				this.loading = true;
				ax.get("/userregistration/all").then(function (response) {
					// console.log(response.data);
					self.data = response.data;
					console.log("StudentIntakes fetched...");
					console.log(self.data);
					self.loading = false;
				});
			},
			// getBanktypes: function() {
			// 	var self = this;
			// 	ax.get("/banktype/all").then(function(response) {
			// 		console.log(response.data);
			// 		self.banktypes = response.data;
			// 	});
			// }
		}
	};
</script>

<!-- Add "slot-scoped" attribute to limit CSS to this component only -->
<style slot-scoped>
</style>